var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-plain-text",attrs:{"data-header":_vm.header}},[(_vm.$slots.default)?_c('div',[_vm._t("default")],2):_vm._e(),(this.content)?_c('div',{domProps:{"innerHTML":_vm._s(this.content)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }